import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Block = styled.a`
    height: 100%;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.2s ease;
    padding: 0.35rem 0.5rem;
    list-style-type: none;
    border-radius: 0.3rem;
    width: 100%;
    box-shadow: 1px 2px 5px #b4b4bb, 0 3px 4px #d2d2d6;
`
export const Container = styled.div`
    display: flex;
    height: 107px;
    padding: 10px 0.5rem 1.5rem 0.5rem;
    box-sizing: border-box;
    justify-content: space-between;
    width: 100%;

    & > ${Block} {
        margin-right: 8px;
    }

    & > ${Block}:last-child {
        margin-right: 0;
    }
`

export const IconContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    height: 28px;
`

export const Icon = styled.img`
    width: auto;
    height: 100%;
`

export const Description = styled.div`
    font-size: 17px;
    font-weight: 500;
    color: ${ThemeColors.getGrayColor()};
    display: flex;
    align-items: center;
`
export const SpanDescription = styled.span`
    //width: 5rem;
`
